import { styled } from '@mui/material'
import { memo } from 'react'
import { Flex } from 'styles'
import { ReactComponent as Checked } from './checked.svg'
import clsx from 'clsx'

const StepWrap = styled(Flex)`
  flex-direction: column;
`
const StepFlag = styled(Flex)`
  align-items: center;
  justify-content: center;
`
const StepItem = styled(Flex)`
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  background: rgba(160, 238, 9, 1);
  color: rgba(22, 25, 30, 1);
  font-weight: 600;
  font-size: 16px;
  border: 4px solid rgba(58, 80, 25, 1);
  margin: 0 -4px;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    background-color: rgba(58, 80, 25, 1);
    border-radius: 50%;
  }

  &.active {
    width: 24px;
    height: 24px;
    background: rgba(160, 238, 9, 1);
    color: ${(props) => props.theme.color.bg};
    border-color: transparent;

    &::after {
      display: none;
    }
  }
`
const StepSpace = styled('div')`
  width: 295px;
  height: 2px;
  background: rgba(160, 238, 9, 1);
  position: relative;
  z-index: 3;
`
const StepTextWrap = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`
const StepText = styled(Flex)`
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: ${(props) => props.theme.color.text100};
  &.active {
    font-weight: 600;
    color: rgba(199, 255, 92, 1);
  }
`

export const OpenMyAccountStep = memo<{ step?: number }>(({ step }) => {
  return (
    <StepWrap>
      <StepFlag>
        <StepItem className="active">
          <Checked />
        </StepItem>
        <StepSpace className="active" />
        <StepItem className={clsx({ active: step === 1 })}>
          {step === 1 ? <Checked /> : null}
        </StepItem>
      </StepFlag>
      <StepTextWrap>
        <StepText>Deposit Assets</StepText>
        <StepText className={'active'}>Activate Account</StepText>
      </StepTextWrap>
    </StepWrap>
  )
})
